<template>
    <div class="auto-response-wrapper">
        <div class="tit">{{ autoRespLabel }}</div>
        <div class="resp-tips">{{ respTips }}</div>
        <Textarea @changeHandle="areaChangeHandle" :data="autoContents" />
    </div>
</template>

<script>
import Textarea from "./Textarea";

export default {
    name: "AutoResponse",
    components: {
        Textarea
    },
    computed: {
        respTips() {
            return this.$t("zhiji.form.autoConfigTip");
        },
        autoRespLabel() {
            return this.$t("zhiji.form.autoConfigTitle");
        },
        autoContents() {
            return this.getStorePorp("formInfo").autoContents || [];
        }
    },
    methods: {
        areaChangeHandle(data) {
            let contents = data.map(item => {
                return {
                    content: item.content
                };
            });

            this.$store.commit("zhiji/updateAutoContents", contents);
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.formEdit[propName];
        }
    }
};
</script>

<style lang="less" scoped>
.auto-response-wrapper {
    padding: 16px;
    background: #fafbfd;

    .tit {
        font-weight: 600;
    }

    .resp-tips {
        color: #9b9ba3;
    }
}
</style>
